import { ScheduleRow } from "entities/weather/model/types";
import { FC } from "react";
import { Tab, Tabs } from "./style";

type DayPartsTabsProps = {
  parts: ScheduleRow["parts"];
};

export const DayPartsTabs: FC<DayPartsTabsProps> = ({ parts }) => {
  return (
    <Tabs>
      {parts.map((part) => (
        <Tab key={part.label}>{part.label}</Tab>
      ))}
    </Tabs>
  );
};
